import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useCircle } from '@/lib/circle/useCircle';

// Gate that sits below ProtectedRoute and inside CircleProvider. Once the
// circle list has loaded, if the user has no circles, send them through
// the onboarding wizard. They can't reach the dashboard / tasks / sage
// etc. without at least one care circle to operate on, so doing this here
// avoids every page needing its own empty-state.
export function RequireOnboarded({ children }: { children: ReactNode }): JSX.Element {
  const { circles, loading } = useCircle();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }
  if (circles.length === 0) {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}
